/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProcedureCreateDto } from '../../models/procedure-create-dto';
import { ProcedureItem } from '../../models/procedure-item';

export interface ProcedureControllerCreate$Params {
      body: ProcedureCreateDto
}

export function procedureControllerCreate(http: HttpClient, rootUrl: string, params: ProcedureControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>> {
  const rb = new RequestBuilder(rootUrl, procedureControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProcedureItem;
      }>;
    })
  );
}

procedureControllerCreate.PATH = '/procedure';
